import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

export const Login = ({ setAuthenticated }) => {
  const [userInput, setUserInput] = useState("")
  const [displayErrorMessage, setDisplayErrorMessage] = useState(false)
  const navigate = useNavigate()
  //   const hiddenPassword = process.env.REACT_APP_WEBSITE_PASSWORD
  // TODO : WARNING
  const hiddenPassword = "CHAMPAGNE!"

  const handleSubmit = () => {
    if (userInput === hiddenPassword) {
      console.log("userInput", userInput)
      setAuthenticated(true)
      navigate("/film")
    } else {
      setDisplayErrorMessage(true)
    }
  }

  // Simplifier le useEffect :
  useEffect(() => {
    // Vérifier directement si l'utilisateur est déjà authentifié
    const isAuth = window.localStorage.getItem("authenticated") === "true"
    if (isAuth) {
      setAuthenticated(true)
      navigate("/film")
    }
  }, [navigate, setAuthenticated])

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: 70
      }}
    >
      <span
        className="cool-title"
        style={{
          marginBottom: 16,
          fontFamily: "Dosis",
          fontWeight: "bolder",
          fontSize: 18
        }}
      >
        LE MOT DE PASSE
      </span>
      <input
        onChange={(e) => setUserInput(e.target.value)}
        style={{ marginBottom: 12, width: 110 }}
        type="password"
        value={userInput}
      />
      <button type="submit " style={{ width: 70 }}>
        Valider
      </button>
      {displayErrorMessage ? (
        <span style={{ color: "red", fontStyle: "italic", fontSize: 12 }}>
          Ce n'est pas le bon mot de passe
        </span>
      ) : null}
    </form>
  )
}
